import { useEffect } from "react";
import { trackClick, type LinkCategory } from "@/utils/trackClick";

const HEYFLOW_MODAL_ID = "u_9gsDM9sg";

const detectCategory = (
  el: HTMLElement,
  href: string | null
): { category: LinkCategory; label: string; url?: string } | null => {
  const text = (el.textContent || "").trim().slice(0, 80);

  if (href?.startsWith("tel:")) {
    return { category: "phone", label: text || "Telefon", url: href };
  }
  if (href?.startsWith("mailto:")) {
    return { category: "email", label: text || "E-Mail", url: href };
  }
  if (href?.includes("provenexpert.com")) {
    return { category: "provenexpert", label: text || "ProvenExpert", url: href };
  }
  if (href?.includes("heyflow")) {
    return { category: "heyflow", label: text || "Heyflow", url: href };
  }

  const lowerText = text.toLowerCase();
  if (
    lowerText.includes("jetzt starten") ||
    lowerText.includes("kostenlose beratung") ||
    lowerText.includes("kostenloses telefongespräch") ||
    lowerText.includes("zum digitalen berater") ||
    lowerText.includes("verrentung berechnen")
  ) {
    return { category: "wizard_cta", label: text, url: href || undefined };
  }
  return null;
};

const ClickTracker = () => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;

      const el = target.closest("a, button") as
        | HTMLAnchorElement
        | HTMLButtonElement
        | null;
      if (!el) return;

      const href =
        el.tagName === "A"
          ? (el as HTMLAnchorElement).getAttribute("href")
          : el.getAttribute("data-href") || null;

      const isHeyflowTrigger =
        el.tagName === "BUTTON" &&
        (el.textContent?.toLowerCase().includes("immobilienwert") ||
          el.getAttribute("data-modal-id") === HEYFLOW_MODAL_ID ||
          el.closest('[data-heyflow-trigger="true"]') !== null);

      if (isHeyflowTrigger) {
        trackClick(
          (el.textContent || "Heyflow Modal").trim().slice(0, 80),
          "heyflow"
        );
        return;
      }

      const detected = detectCategory(el, href);
      if (detected) {
        trackClick(detected.label, detected.category, detected.url);
      }
    };

    document.addEventListener("click", handler, { capture: true });
    return () =>
      document.removeEventListener("click", handler, { capture: true });
  }, []);

  return null;
};

export default ClickTracker;
